import { useState } from 'react';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center">
            <a href="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/1bbfa2f32c0e742fa111fb11370c4024/cb89370780a4b5b8aeed7efe5837b533.png" 
                alt="PUMA" 
                className="h-12"
              />
            </a>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center space-x-8">
            <a href="/" className="text-sm font-medium hover:text-gray-600 whitespace-nowrap">Ana Sayfa</a>
            <a href="/puma" className="text-sm font-medium hover:text-gray-600 whitespace-nowrap">Puma</a>
            <a href="#" className="text-sm font-medium hover:text-gray-600 whitespace-nowrap">Kadın</a>
            <a href="#" className="text-sm font-medium hover:text-gray-600 whitespace-nowrap">Erkek</a>
            <a href="#" className="text-sm font-medium hover:text-gray-600 whitespace-nowrap">Çocuk</a>
            <a href="#" className="text-sm font-medium hover:text-gray-600 whitespace-nowrap">Koleksiyonlar</a>
            <a href="#" className="text-sm font-medium hover:text-gray-600 whitespace-nowrap">Spor</a>
          </nav>

          {/* Right Icons */}
          <div className="flex items-center space-x-4">
            <button className="hidden md:flex items-center space-x-2 text-sm hover:text-gray-600 cursor-pointer">
              <i className="ri-search-line text-xl"></i>
            </button>
            <button className="hover:text-gray-600 cursor-pointer">
              <i className="ri-user-line text-xl"></i>
            </button>
            <button className="hover:text-gray-600 cursor-pointer">
              <i className="ri-heart-line text-xl"></i>
            </button>
            <button className="hover:text-gray-600 cursor-pointer relative">
              <i className="ri-shopping-bag-line text-xl"></i>
              <span className="absolute -top-1 -right-1 bg-black text-white text-xs rounded-full w-4 h-4 flex items-center justify-center">0</span>
            </button>
            <button 
              className="lg:hidden hover:text-gray-600 cursor-pointer"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <i className="ri-menu-line text-xl"></i>
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="lg:hidden border-t border-gray-200 py-4">
            <nav className="flex flex-col space-y-4">
              <a href="/" className="text-sm font-medium hover:text-gray-600">Ana Sayfa</a>
              <a href="/puma" className="text-sm font-medium hover:text-gray-600">Puma</a>
              <a href="#" className="text-sm font-medium hover:text-gray-600">Kadın</a>
              <a href="#" className="text-sm font-medium hover:text-gray-600">Erkek</a>
              <a href="#" className="text-sm font-medium hover:text-gray-600">Çocuk</a>
              <a href="#" className="text-sm font-medium hover:text-gray-600">Koleksiyonlar</a>
              <a href="#" className="text-sm font-medium hover:text-gray-600">Spor</a>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
}
